(function($){

	let $form = $("form.checkout_form"),
		$shipping_fields = $form.find(".woocommerce-shipping-fields")

    // Hide shipping fields on page load when a custom shipping method is selected
    let selected_method = $form.find("input[name='shipping_method']:checked")
    if (selected_method && selected_method.data("method-id") !== 'custom'){
        $shipping_fields.hide()
    }

	$(document).gp_ready(function(){

		// Open widget on shipping method change to "zasilkovna_pick_up_point"
		$form.find("input[name='shipping_method']").change(function(){
			let method_id = $(this).data("method-id")
			if(method_id === "zasilkovna_pick_up_point"){
				// Open widget
				open_widget()
				// Hide shipping address fields
				$shipping_fields.hide()
			}else if (method_id === "custom"){
				// Close widget
				close_widget()
				// Show shipping address fields
				$shipping_fields.show()
			}
		})

		// Open widget on choose button click
		$form.find('.zas-pop-kont').off("click").click(function(){
			$('.zas-pop-kont').addClass('loading');
			setTimeout(function(){
				$('.zas-pop-kont').removeClass('loading');
			}, 3000);

			open_widget()
		});

		//  Display chosen branch
		update_data_from_session()

	})

	function open_widget(){

		let country = $form.find("select[name='billing_country'], input[name='billing_country']").val()
		if(!country){
			alert("Nebyla vybrána země doručení.")
			return;
		}

        // Limit end carriers for some countries
        country = country.toLowerCase()
        let packetaOptions = {
            "country": country,
            "language": zasilkovna_widget_params.language
        }

        // vendors can be found here: https://configurator.widget.packeta.com/cs
        switch (country) {
            case "es":
                packetaOptions.vendors = [
                    {
                        group: "es-mrw-pp",
                        carrierId: "4654"
                    }
                ]
                break;
            case "fi":
                packetaOptions.vendors = [
                    {
                        group: "fi-matkahuolto-box",
                        carrierId: "26987"
                    },
                    {
                        group: "fi-matkahuolto-pp",
                        carrierId: "26986"
                    }
                ]
                break;
            case "fr":
                packetaOptions.vendors = [
                    {
                        group: "fr-mondial-relay-pp",
                        carrierId: "12889"
                    }
                ]
                break;
            case "nl":
                packetaOptions.vendors = [
                    {
                        group: "nl-dhl-pp",
                        carrierId: "8001"
                    }
                ]
                break;
            case "pl":
                packetaOptions.vendors = [
                    {
                        group: "pl-paczkomaty",
                        carrierId: "3060"
                    }
                ]
                break;
            case "hu":
                packetaOptions.vendors = [
                    {
                        group: "hu-foxpost-box",
                        carrierId: "32970"
                    }
                ]
                break;
            case "ro":
                packetaOptions.vendors = [
                    {
                        group: "rosamedaybox",
                        carrierId: "7455"
                    }
                ]
                break;
            case "lt":
                packetaOptions.vendors = [
                    {
                        group: "lt-omniva-box",
                        carrierId: "5066"
                    }
                ]
                break;
            case "lv":
                packetaOptions.vendors = [
                    {
                        group: "lv-omniva-box",
                        carrierId: "5064",
                    }
                ]
                break;
            case "ee":
                packetaOptions.vendors = [
                    {
                        group: "ee-omniva-box",
                        carrierId: "5062",
                    },
                    {
                        group: "ee-omniva-pp",
                        carrierId: "5061",
                    }
                ]
                break;
        }

		// Open widget
		Packeta.Widget.pick(
			zasilkovna_widget_params.zasilkovna_api_key,
			widget_callback,
            packetaOptions
		)
	}

	// Close
	function close_widget(){
		Packeta.Widget.close();
	}

	function widget_callback(locationData) {

		if (locationData != null && typeof locationData !== "undefined") {

			let address_1;
			let address_2;
            let branch_id;

			// Get the address either from sessionStorage, or split "street" data returned by the widget
			if (typeof locationData.address_1 === "undefined") {
				let addressData = locationData.street.split(/(?= \d|\D+$)/);
				address_1 = addressData[0].trim();
				address_2 = addressData[1].trim();
			} else {
				address_1 = locationData.address_1;
				address_2 = locationData.address_2;
			}
            // fix for Balikobot - it expects different format for external carriers
            if(typeof locationData.carrierId !== "undefined" && locationData.carrierId && typeof locationData.carrierPickupPointId !== "undefined" && locationData.carrierPickupPointId){
                branch_id = locationData.carrierId + '-' + locationData.carrierPickupPointId;
            }else{
                branch_id = locationData.id;
            }

			jQuery("input[name='zasilkovna_shipping_address_1']").val(address_1);
			jQuery("input[name='zasilkovna_shipping_address_2']").val(address_2);
			jQuery("input[name='zasilkovna_shipping_city']").val(locationData.city);
			jQuery("input[name='zasilkovna_shipping_company']").val(locationData.place);
			jQuery("input[name='zasilkovna_shipping_country']").val(locationData.country.toUpperCase());
			jQuery("input[name='zasilkovna_shipping_postcode']").val(locationData.zip);
			jQuery("input[name='zasilkovna_branch_id']").val(branch_id);

			// Save the data into the session to be able to access it in the second step
			sessionStorage.setItem( "gp_zasilkovna_branch_info", JSON.stringify(locationData) );

			// Display chosen pickup point
			display_chosen_pickup_point(locationData)

			return true;
		}

		return false;
	}

	function display_chosen_pickup_point(locationData){

		// Change button text
        const btn = $form.find("a.zas-pop-kont")
        if (btn){
            btn.text(btn.data('label-change'));
        }

		// Display address
		$form.find(".zasilkovna_branch").show();
		let addressOutput = '<a href="'+locationData.url+'" target="_blank">'+locationData.place+'</a><br>'+locationData.name+'<br>';
		$form.find("p#zasilkovna_branch-address").html(addressOutput);
	}

	function update_data_from_session(){

		let locationData = sessionStorage.getItem("gp_zasilkovna_branch_info")
		if(!locationData){
			return;
		}

		locationData = JSON.parse(locationData)
		widget_callback(locationData)
	}

})(jQuery)
